import { ReactElement } from 'react';
import { BlocksCloseEvent } from '@blocks-web-components/events';
import { useDrawer } from '../../../hooks/useDrawer';
import styles from '../MyEquipment.module.scss';
import { Drawer } from '../../common';

type MyEquipmentDrawerProps = {
  drawer: ReturnType<typeof useDrawer>;
  children: ReactElement | ReactElement[];
  size: 'default' | 'lg';
  onCloseHandler: (e: BlocksCloseEvent) => void;
  isChild: false | true;
};

export const MyEquipmentDrawer = ({
  children,
  drawer,
  size = 'default',
  onCloseHandler,
  isChild = false
}: MyEquipmentDrawerProps) => {
  return (
    <Drawer
      {...drawer.drawerProps}
      onBlDrawerClose={onCloseHandler}
      className={`${styles['drawer']}`}
      size={size}
      hideCloseButton={isChild}
      disableBackdropClick={isChild}
    >
      {children}
    </Drawer>
  );
};
